// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const validationErrorFieldSchema = z.object({
  fieldName: z.string(),
  error: z.string(),
  errorCode: z.number(),
});

export type ValidationErrorField = z.infer<typeof validationErrorFieldSchema>;

export const rowValidationErrorSchema = z.object({
  index: z.number(),
  errors: z.array(validationErrorFieldSchema),
});

type RowValidationError = z.infer<typeof rowValidationErrorSchema>;

/** The generic importer response envelope shared by every CSV uploader endpoint */
export interface CsvImportEnvelope {
  success: boolean;
  items: unknown[];
  structureErrors: ValidationErrorField[];
  rowErrors: RowValidationError[];
}
